import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'
import { SensorTypes, sensorTypeToMapboxExpression } from '@/utils/format-sensor-values'
import useMapbox from '@/composables/useMapbox'
import { FillLayer } from 'mapbox-gl'

interface PROPS {
  before: string
  layerId: string
  source: any
  currentSensordataType: SensorTypes
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LayerSensorData',
  props: {
    before: {},
    layerId: {},
    source: {},
    currentSensordataType: {}
  },
  setup(__props: any) {

const { map } = useMapbox()
const store = useStore()

const props = __props
const { before, layerId, source, currentSensordataType } = toRefs(props)

const isMeasurementActive = computed<boolean>(() => store.getters.isMeasurementActive)
const fillColor = computed(() => {
  return sensorTypeToMapboxExpression(currentSensordataType.value)
})

const layerStyle = computed<FillLayer>(() => {
  return {
    id: layerId.value,
    source: source.value.data.id,
    type: 'fill',
    paint: {
      'fill-color': fillColor.value,
      'fill-opacity': 0.5,
      'fill-outline-color': '#ffffff'
    },
    minzoom: 10
  }
})

function handleClick(event) {
  if (isMeasurementActive.value || !isRoomLayer(event)) return
  store.dispatch('CHANGE_ROOM', { roomId: event.features[0].properties.id })
  store.commit('SET_CLICKED_ITEM_TYPE', { type: 'room' })
}

function handleMouseEnter() {
  if (isMeasurementActive.value) return
  map.getCanvas().style.cursor = 'pointer'
}

function handleMouseLeave() {
  if (isMeasurementActive.value) return
  map.getCanvas().style.cursor = ''
  store.commit('planview/SET_HOVERED_ROOM_AND_SENSOR_VALUE', null)
}

function handleMouseMove(event) {
  if (isMeasurementActive.value) return
  updateOnHover(event)
}

function isRoomLayer(event) {
  const renderedFeatures = map.queryRenderedFeatures(event.point)
  if (!renderedFeatures.length) return false
  const isVisiblePoiHovered = renderedFeatures.findIndex(
    (feature) => feature.layer.id === 'layer-room-marker-poi'
  )
  return isVisiblePoiHovered === -1
}

function updateOnHover(event) {
  if (!event.features[0]) return
  const value = event.features[0].properties[currentSensordataType.value]
  const room = event.features[0].properties.displayName
  store.commit('planview/SET_HOVERED_ROOM_AND_SENSOR_VALUE', { room, value })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeojsonLayer, {
    before: _unref(before),
    layer: layerStyle.value,
    layerId: _unref(layerId),
    source: _unref(source),
    sourceId: _unref(source).data.id,
    onLayerClicked: handleClick,
    onLayerMouseEnter: handleMouseEnter,
    onLayerMouseLeave: handleMouseLeave,
    onLayerMouseMove: handleMouseMove
  }, null, 8, ["before", "layer", "layerId", "source", "sourceId"]))
}
}

})